import { mapState } from 'vuex'

export default {
  computed: mapState({
    close: state => state.modal.close,
    dismiss: state => state.modal.dismiss
  })
}
